var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bit-square flex-row justify-content-center",class:_vm.isActive ? `bg-${_vm.colorName}-color` : 'bg-neutral-color-2'},[_c('p',{class:_vm.isActive ? 'typography-neutral-color-1' : 'typography-neutral-color-10'},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }